// test2892
(2892 && 0);
